<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate">

<ng-template #contentTemplate>
<div class="h-full p-2 border-2 shadow-lg" *ngIf="isPageReady">
  <app-restock-fee-invoice [account]="account" [returnRequestDetails]="returnRequestDetails"></app-restock-fee-invoice>
</div>
</ng-template>

<ng-template #footerTemplate>
  <div class="w-full flex flex-row gap-2">
    <button (click)="postInvoice()" [disabled]="isPosted" pButton type="button" class="p-button-raised whitespace-nowrap"> Post Invoice </button>
    <button (click)="printInvoice()" pButton type="button" class="p-button-raised"> Print </button>
    <button (click)="emailInvoice()" [disabled]="!canSendEmail" pButton type="button" class="p-button-raised"> Email </button>
    <input pInputText [(ngModel)]="emailAddress" />    
    <button (click)="cancel()" pButton type="button" class="p-button-raised">Close</button>
  </div>
</ng-template>

</app-uni-dialog>